import { createStyles } from '@mantine/core';

type StyleArgs = { isSidePanel?: boolean };

const useStyles = createStyles((theme, { isSidePanel }: StyleArgs) => ({
  dimmedText: {
    color: theme.colors.gray[5],
    ...(isSidePanel
      ? {
          fontSize: theme.fontSizes.xs,
        }
      : {
          [theme.fn.smallerThan('xs')]: {
            fontSize: theme.fontSizes.xs,
          },
        }),
  },
  contestInfo: {
    ...(isSidePanel
      ? {}
      : {
          [theme.fn.largerThan('xs')]: {
            transitionDuration: '.35s',
            transitionTimingFunction: 'linear',
            transitionProperty: 'font-size',
          },
        }),
  },
  flex: {
    display: 'flex',
    gap: theme.spacing.sm / 2,
    ...(isSidePanel
      ? {
          flexDirection: 'column',
          gap: 0,
        }
      : {
          [theme.fn.smallerThan('xs')]: {
            flexDirection: 'column',
            gap: 0,
          },
        }),
  },
  subHeader: {
    alignItems: 'center',
    display: 'flex',
    opacity: 1,
    transitionDuration: '.35s',
    transitionTimingFunction: 'linear',
    transitionProperty: 'opacity',
  },
  button: {
    minWidth: 100,
  },
  action: {
    minWidth: 'max-content',
  },
  edit: {
    position: 'absolute',
    right: 0,
    top: 0,
    fontWeight: 'bold',
    zIndex: 2,

    '&:hover': {
      background: 'transparent',
    },
  },
}));

export default useStyles;
